import type { TenantLocaleOverrides } from '../base';
import { AZOverrides } from './AZ';
import { CAOverrides } from './CA';
import { COOverrides } from './CO';
import { DCOverrides } from './DC';
import { FLOverrides } from './FL';
import { GAOverrides } from './GA';
import { KYOverrides } from './KY';
import { MAOverrides } from './MA';
import { MDOverrides } from './MD';
import { NCOverrides } from './NC';
import { NVOverrides } from './NV';
import { NYOverrides } from './NY';
import { OHOverrides } from './OH';
import { SCOverrides } from './SC';
import { TXOverrides } from './TX';
import { VAOverrides } from './VA';

export const overrides: Record<string, TenantLocaleOverrides> = {
  AZ: AZOverrides,
  CA: CAOverrides,
  CO: COOverrides,
  DC: DCOverrides,
  FL: FLOverrides,
  GA: GAOverrides,
  KY: KYOverrides,
  MA: MAOverrides,
  MD: MDOverrides,
  NC: NCOverrides,
  NV: NVOverrides,
  NY: NYOverrides,
  OH: OHOverrides,
  SC: SCOverrides,
  TX: TXOverrides,
  VA: VAOverrides,
};
